import { StateType } from "@/redux/createStore"
import { createSelector } from "reselect"

export const getCategories = createSelector(
  (state: StateType) => state.categories,
  (data) => data
)
